import { render, staticRenderFns } from "./FileLeftSidebar.vue?vue&type=template&id=628df70e&"
import script from "./FileLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./FileLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FileLeftSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports